import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { css, Theme } from '@emotion/react';
import { transparentize } from 'polished';
import { muiTheme } from 'client/Theme';

export type TabProps = {
  id: string;
  title: ReactNode;
  icon?: JSX.Element;
  href?: React.ComponentProps<typeof Link>['to'];
  disabled?: boolean;
};

export const tabStyle = (theme: Theme) => css`
  position: relative;
  background: linear-gradient(to bottom, ${theme.color.background} 40%, ${theme.color.background});
  border: 2px solid ${theme.color.grey[60]};

  transition: ${muiTheme.transitions.create(['background-color', 'border-top-color', 'border-left-color', 'border-right-color'])};

  &.MuiButtonBase-root.MuiTab-root {
    border-radius: ${theme.borderRadius}px ${theme.borderRadius}px 0 0;
  }

  &.Mui-disabled {
    border-style: dashed;
    border-bottom-style: solid;

    .MuiTab-wrapper .typography,
    .typography {
      color: ${theme.color.grey[80]};
    }
  }

  &.Mui-selected {
    background: linear-gradient(
      to bottom,
      ${transparentize(theme.type === 'light' ? 0.35 : 0, theme.color.primary[60])} 40%,
      ${theme.color.background}
    );
    border-color: ${theme.color.primary[100]};
    border-bottom: none;
    padding-bottom: 14px;

    .MuiTab-wrapper .typography,
    .typography {
      color: ${theme.color.primary.text};
    }
  }

  .MuiMenuItem-root {
    &:not(:first-of-type):not(.link) {
      margin-top: 0.25rem;
    }
  }
`;

export const tabTextStyle = (theme: Theme) => css`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: -3px;
  font-family: ${theme.font.header};
  font-weight: 500 !important;
  text-transform: none !important;

  > svg {
    transform: translateY(-2px);
    opacity: 0.8;
  }
`;
